module.exports = __webpack_public_path__ + "b3a9cf14629e05b988a636a2cc83b382.png";